// ErrorPage.jsx
import React from 'react'
import { useNavigate } from 'react-router-dom'

const ErrorPage = () => {
  const navigate = useNavigate()

  return (
    <div className="error-wrapper">
      <div className="error-card">
        <h1 className="error-code">404</h1>
        <h2 className="error-title">Page not found</h2>
        <p className="error-description">
          The page you are trying to access does not exist or has been moved.
        </p>

        <div className="error-actions">
          <button
            className="btn btn-primary"
            onClick={() => navigate('/')}
          >
            Go Home
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  )
}

export default ErrorPage